import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Glyphicon, Row, Col} from 'react-bootstrap';
import Papa from 'papaparse';
// import FmlxNumericInputWithButton from '../../../components/FmlxNumericInputWithButton';
import {WellIncrementPattern} from '../../../constants/dataEnum';
import './NormalizationContainer.scss';

/* eslint-disable */
class NormalizationViewFileSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialDelimiter: this.props.normalizationState.delimiter,
      initialStartRow: this.props.normalizationState.startRow,
      initialColumnInFirstRow: this.props.normalizationState.isColumnInFirstRow,
      initialWellIncrementPattern: this.props.normalizationState.wellIncrementPattern,
    };
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.normalizationState.delimiter !== nextProps.normalizationState.delimiter) {
      return true;
    }
    if (this.props.normalizationState.startRow !== nextProps.normalizationState.startRow) {
      return true;
    }
    if (
      this.props.normalizationState.isColumnInFirstRow !==
      nextProps.normalizationState.isColumnInFirstRow
    ) {
      return true;
    }
    if (
      this.props.normalizationState.wellIncrementPattern !==
      nextProps.normalizationState.wellIncrementPattern
    ) {
      return true;
    }
    if (this.props.normalizationState.csvRawData !== nextProps.normalizationState.csvRawData) {
      return true;
    }
    if (this.props.normalizationState.totalRow !== nextProps.normalizationState.totalRow) {
      return true;
    }
    return false;
  }

  handleClickResetButton() {
    this.props.setCsvDelimiter(this.state.initialDelimiter);
    this.props.setCsvStartRow(this.state.initialStartRow);
    this.props.setCsvColumnInFirstRow(this.state.initialColumnInFirstRow);
    this.props.setWellIncrementPattern(this.state.initialWellIncrementPattern);
    this.handleChangeDelimiter(this.state.initialDelimiter);
  }

  handleChangeSwitch(event) {
    this.props.setCsvColumnInFirstRow(event.target.checked);

    if (this.props.normalizationState.startRow < 2) {
      this.props.setCsvStartRow(2);
    }
  }

  handleChangeWellIncrementPattern(event) {
    this.props.setWellIncrementPattern(event.target.value);
  }

  handleChangeDelimiter(value) {
    if (value && value !== this.props.normalizationState.delimiter) {
      if (this.props.normalizationState.csvRawData) {
        const data = Papa.parse(this.props.normalizationState.csvRawData, {
          delimiter: value,
          dynamicTyping: true,
          skipEmptyLines: 'greedy',
        });

        // store the state
        this.props.setCsvData(data.data);
        this.props.setCsvTotalRow(data.data.length);
        this.props.setSelectedColumnIndex(null);
        this.props.setAllowedToNext(false);
      }
    }

    this.props.setCsvDelimiter(value);
  }

  handleIncrementStartRow() {
    if (this.props.normalizationState.startRow < this.props.normalizationState.totalRow) {
      this.props.setCsvStartRow(this.props.normalizationState.startRow + 1);
    }
  }

  handleDecrementStartRow() {
    if (this.props.normalizationState.isColumnInFirstRow) {
      if (this.props.normalizationState.startRow > 2) {
        this.props.setCsvStartRow(this.props.normalizationState.startRow - 1);
      }
    } else {
      if (this.props.normalizationState.startRow > 1) {
        this.props.setCsvStartRow(this.props.normalizationState.startRow - 1);
      }
    }
  }

  render() {
    const {
      delimiter,
      startRow,
      isColumnInFirstRow,
      wellIncrementPattern,
    } = this.props.normalizationState;

    return (
      <div className="setting-container">
        <div className="setting-info-section">
          <Row>
            <Col xs={9} sm={9} md={9} className={'setting-info-text'}>
              {
                'Specify the file format and conversion options for the data. Then, specify the target plate definition.'
              }
            </Col>
            <Col xs={3} sm={3} md={3}>
              <Button className="setting-info-button" onClick={() => this.handleClickResetButton()}>
                <Glyphicon glyph={'repeat'} />
              </Button>
            </Col>
          </Row>
        </div>
        <div className="spacer-v">&nbsp;</div>
        <div className="block-section">
          <div className="sub-section-title">File Settings</div>
          <Row>
            <Col xs={5} sm={5} md={5} style={{ fontSize: '12px' }}>
              Column Delimiter
            </Col>
            <Col xs={7} sm={7} md={7} style={{ fontSize: '12px' }}>
              Start Row
            </Col>
          </Row>
          <Row>
            <Col xs={5} sm={5} md={5}>
              <input
                className="setting-input"
                type="text"
                value={delimiter}
                onChange={(event) => this.handleChangeDelimiter(event.target.value)}
              />
            </Col>
            <Col xs={7} sm={7} md={7}>
              <Button className="plus-minus-button" onClick={() => this.handleIncrementStartRow()}>
                <Glyphicon glyph="plus" />
              </Button>
              <input
                className="setting-input"
                type="text"
                placeholder="0"
                value={startRow}
                readOnly
              />
              <Button className="plus-minus-button" onClick={() => this.handleDecrementStartRow()}>
                <Glyphicon glyph="minus" />
              </Button>
            </Col>
          </Row>
          <Row style={{ marginTop: '16px' }}>
            <Col xs={9} sm={9} md={9}>
              Column names are in the first row
            </Col>
            <Col xs={3} sm={3} md={3}>
              <label className="switch">
                <input
                  type="checkbox"
                  onChange={(event) => this.handleChangeSwitch(event)}
                  checked={isColumnInFirstRow}
                />
                <span className="slider round" />
              </label>
            </Col>
          </Row>
        </div>
        <div className="spacer-v">&nbsp;</div>
        <div className="block-section">
          <div className="sub-section-title">Well number increments by</div>
          <label className="radio-button-container">
            {'Row : A1,A2,A3,...'}
            <input
              type="radio"
              name="wellIncrementPattern"
              value={WellIncrementPattern.ORDER_BY_ROW}
              onChange={(event) => this.handleChangeWellIncrementPattern(event)}
              checked={wellIncrementPattern === WellIncrementPattern.ORDER_BY_ROW}
            />
            <span className="custom-radio-button" />
          </label>
          <label className="radio-button-container">
            {'Column : A1,B1,C1,...'}
            <input
              type="radio"
              name="wellIncrementPattern"
              value={WellIncrementPattern.ORDER_BY_COLUMN}
              onChange={(event) => this.handleChangeWellIncrementPattern(event)}
              checked={wellIncrementPattern === WellIncrementPattern.ORDER_BY_COLUMN}
            />
            <span className="custom-radio-button" />
          </label>
        </div>
      </div>
    );
  }
}

export default NormalizationViewFileSetting;

NormalizationViewFileSetting.propTypes = {
  normalizationState: PropTypes.any,
  setCsvDelimiter: PropTypes.func,
  setCsvStartRow: PropTypes.func,
  setCsvColumnInFirstRow: PropTypes.func,
  setWellIncrementPattern: PropTypes.func,
  setCsvData: PropTypes.func,
  setCsvTotalRow: PropTypes.func,
  setSelectedColumnIndex: PropTypes.func,
  setAllowedToNext: PropTypes.func,
};
/* eslint-enable */
